import { render, staticRenderFns } from "./HsCodeIDPop.vue?vue&type=template&id=b7de75c0"
import script from "./HsCodeIDPop.vue?vue&type=script&lang=js"
export * from "./HsCodeIDPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7de75c0')) {
      api.createRecord('b7de75c0', component.options)
    } else {
      api.reload('b7de75c0', component.options)
    }
    module.hot.accept("./HsCodeIDPop.vue?vue&type=template&id=b7de75c0", function () {
      api.rerender('b7de75c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/HsCodeIDPop.vue"
export default component.exports